import { type CreateOrUpdateAuthorModel } from '@/shared/api'

import type { AuthorFormModel } from '..'

export function getAuthorRequestByFormValues(
  values: AuthorFormModel,
): CreateOrUpdateAuthorModel {
  return {
    nickname: values.nickname.trim(),
    description: values.description ? values.description.trim() : null,
    contactInfo: values.contactInfo ? values.contactInfo.trim() : null,
    church: values.church ? values.church.trim() : null,
    pictureFileId: values.avatar?.id ?? null,
  }
}
